// @flow

export function prettyPrintNumber (num: number): string {
  return String(num).replace('.', ',')
}



// WEBPACK FOOTER //
// ./src/v1/components/helpers/prettyPrintNumber.js